import React from 'react';
import { FormControlLabel, RadioGroup } from '@mui/material';
import RadioButton from '../../Utils/RadioButton';
import useTailwindBrand from '../../Theme/useTailwindBrand';
import { getBrandConfig } from '../../config/brandConfig';

interface FormRadioYesNoProps {
    label: string;
    value: number; // 1 = Oui, 2 = Non, 0 = non sélectionné
    onChange: (value: number) => void;
    error?: string;
    required?: boolean;
    name?: string;
    subtitle?: React.ReactNode;
}

const FormRadioYesNo: React.FC<FormRadioYesNoProps> = ({
    label,
    value,
    onChange,
    error,
    required = false,
    name,
    subtitle
}) => {
    const { classes, common } = useTailwindBrand();
    const brandConfig = getBrandConfig();

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = parseInt(event.target.value);
        onChange(newValue);
    };

    return (
        <div className="/space-y-2 ">
            <label className={`block ${common.body} font-semibold mb-1 ${classes.fontFamily} ${error ? classes.error : classes.text}`}>
                {label} {required && <span className={classes.error}>*</span>}
            </label>
            {subtitle}
            {/* <span className={`md:text-base text-xs ${classes.fontFamily} font-medium italic`}>{subtitle}</span> */}
            <RadioGroup
                row
                value={value.toString()}
                onChange={handleChange}
                name={name}
                className="flex flex-row gap-x-6 "
            >
                <FormControlLabel
                    sx={{
                        '& .MuiFormControlLabel-label': {
                            color: brandConfig.colors.text,
                            fontFamily: brandConfig.fontFamily,
                            fontSize: "16px"
                        }
                    }}
                    value="1"
                    control={
                        <RadioButton
                            border={`1px solid ${brandConfig.colors.primary}`}
                            bg={brandConfig.colors.primary}
                        />
                    }
                    label="Oui"
                />
                <FormControlLabel
                    sx={{
                        '& .MuiFormControlLabel-label': {
                            color: brandConfig.colors.text,
                            fontFamily: brandConfig.fontFamily,
                            fontSize: "16px"
                        }
                    }}
                    value="2"
                    control={
                        <RadioButton
                            border={`1px solid ${brandConfig.colors.primary}`}
                            bg={brandConfig.colors.primary}
                        />
                    }
                    label="Non"
                />
            </RadioGroup>
                <p className={`md:text-sm text-xs mt-1 h-4 ${classes.error} font-medium`}>
                    {error || null}
                </p>
            {/* {error && (
                <p className={`md:text-sm text-xs mt-1 h-4 ${classes.error} ${classes.fontFamily} font-medium`}>
                    {error}
                </p>
             )}  */}
        </div>
    );
};

export default FormRadioYesNo;
